import { AIMessage } from "@langchain/core/messages";
import { v4 as uuidv4 } from "uuid";
import {
  type ChatMessage,
  type ChatSubmitMessage,
  getChatMessageType,
} from "./types";

export const DO_NOT_RENDER_ID_PREFIX = "do-not-render-";

const getToolCalls = (message: ChatMessage) => {
  if (AIMessage.isInstance(message)) {
    return message.tool_calls ?? [];
  }

  return Array.isArray(message.tool_calls) ? message.tool_calls : [];
};

export function ensureToolCallsHaveResponses(messages: ChatMessage[]) {
  const newMessages: ChatSubmitMessage[] = [];

  messages.forEach((message, index) => {
    const toolCalls = getToolCalls(message);

    if (getChatMessageType(message) !== "ai" || toolCalls.length === 0) {
      // If it's not an AI message, or it doesn't have tool calls, we can ignore.
      return;
    }
    // If it has tool calls, ensure the message which follows this is a tool message
    const followingMessage = messages[index + 1];
    if (followingMessage && getChatMessageType(followingMessage) === "tool") {
      // Following message is a tool message, so we can ignore.
      return;
    }

    // Since the following message is not a tool message, we must create a new tool message
    newMessages.push(
      ...toolCalls.map((tc) => ({
        type: "tool" as const,
        role: "tool" as const,
        tool_call_id: tc.id ?? "",
        id: `${DO_NOT_RENDER_ID_PREFIX}${uuidv4()}`,
        name: tc.name,
        content: "Successfully handled tool call.",
      }))
    );
  });

  return newMessages;
}
